import { MediaTypeEnum } from '../../Basic/enums/media-type.enum';

export const socialThumbnailDefaultImage = {
    [MediaTypeEnum.FACEBOOK]  : 'assets/images/placeholder-facebook.svg',
    [MediaTypeEnum.INSTAGRAM] : 'assets/images/placeholder-instagram.svg',
    [MediaTypeEnum.REDDIT]    : 'assets/images/placeholder-reddit.svg',
    [MediaTypeEnum.TWITTER]   : 'assets/images/placeholder-twitter.svg',
    [MediaTypeEnum.YOUTUBE]   : 'assets/images/placeholder-youtube.svg',
    [MediaTypeEnum.BLUESKY]   : 'assets/images/placeholder-bluesky.svg'
};
